import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Button, Menu, MenuHandler, MenuList, MenuItem } from '@material-tailwind/react';

import { supportedLngs } from "./config";

import { useAppDispatch } from "../state/hooks";
import { setLanguage } from "../slices/local/user";

import flagDe from '../../node_modules/flag-icons/flags/1x1/de.svg';
import flagGb from '../../node_modules/flag-icons/flags/1x1/gb.svg';

const flagMap = {
  de: flagDe,
  gb: flagGb,
  en: flagGb,
};

function FlagIcon({ countryCode = "" }) {
  const src = flagMap[countryCode] || flagMap['gb'];

  return (
    <img
      src={src}
      alt={countryCode}
      className="w-9 h-9 inline-block md:mr-2 rounded-full object-cover border-none"
      style={{ boxShadow: 'inset 0 0 0 2px rgba(0, 0, 0, .06)' }}
    />
  );
}

function getLanguageNameByKey(key) {
  const language = supportedLngs.find(language => language.key === key);
  return language ? language.name : null;
}

export default function LocaleSwitcher() {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const [openMenu, setOpenMenu] = useState(false);
  const selectedLanguage = supportedLngs.find(language => language.key === i18n.language);

  const handleLanguageChange = async (language) => {
    dispatch(setLanguage({
      language
    }));

    // @todo works but -> dedicated middleware
    await i18n.changeLanguage(language.key);
  };

  return (
    <Menu open={openMenu} handler={setOpenMenu} allowHover>
      <MenuHandler className="rounded-md p-1 hover:opacity-75 active:opacity-[0.85] flex items-center gap-2 shadow-sm  text-sm font-medium text-black md:hover:bg-yellow-200 md:bg-yellow">
        <Button
          size="sm"
          variant="text"
          className="flex items-center gap-2 md:border md:border-yellow-300 shadow-sm md:bg-yellow text-sm font-medium text-gray-700 hover:bg-yellow-50 md:focus:outline-hidden"
        >
          <FlagIcon countryCode={i18n.resolvedLanguage} />
          <div className="hidden md:flex items-center gap-2">
            {getLanguageNameByKey(i18n.resolvedLanguage)}
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className={`size-6 h-3.5 w-3.5 transition-transform ${openMenu ? "rotate-180" : ""}`}>
              <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
            </svg>
          </div>
        </Button>
      </MenuHandler>
      <MenuList className="max-h-72 w-20">
        {supportedLngs.map((language) => (
          <MenuItem key={language.key}
            className={`${selectedLanguage.key === language.key
              ? "bg-gray-100 text-gray-900"
              : "text-gray-700"
              } flex items-center gap-2`}
            onClick={() => handleLanguageChange(language)}>
            <FlagIcon countryCode={language.key} /> {language.name}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}